<div class="modal-content">
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Atenção</h4>
  </div>
  <div class="modal-body">
    <span class="icon cancel"></span>
    <p text-align-center>
      Para enviar os documentos do cliente é obrigatório que o pré-contrato seja
      gerado.
    </p>
    <strong
      ><p text-align-center>
        Por isso, volte na etapa de Emissão do Pré-contrato e conclua a sua
        emissão para continuar com o envio dos documentos.
      </p></strong
    >
  </div>
  <div class="modal-footer" text-align-center>
    <button type="button" class="btn btn-default custom-button" (click)="modal.hide()">
      Entendi
    </button>
  </div>
</div>
